import { createContext } from 'react'

export enum ColorScheme {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

type ColorSchemeContextType = {
  colorScheme: ColorScheme
  setColorScheme: React.Dispatch<React.SetStateAction<ColorScheme>>
  isDarkMode: boolean
}

export const ColorSchemeContext = createContext<ColorSchemeContextType>({
  colorScheme: ColorScheme.System,
  setColorScheme: () => {},
  isDarkMode: false,
})
